import React from 'react';
import { Button, Tooltip } from 'antd';
import { FaRegTrashAlt } from 'react-icons/fa';

const SectionHeader = ({ label, onRemove }) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      width: '100%'
    }}
    className="gx-mt-2 gx-mb-2"
  >
    <span style={{ whiteSpace: 'nowrap' }}>{label}</span>

    <div
      style={{
        flex: 1,
        height: 0.8,
        backgroundColor: '#f0f0f0',
        marginLeft: 8,
        marginRight: onRemove ? 8 : 0
      }}
    />

    {onRemove && (
      <Tooltip title="Excluir">
        <Button type="text" size="small" onClick={onRemove}>
          <FaRegTrashAlt className="gx-pointer" />
        </Button>
      </Tooltip>
    )}
  </div>
);

export default SectionHeader;
